import React from "react";
import "./LegalPages.css"; // reuse your styling
import {
  FaPhone,
  FaEnvelope,
  FaMapMarkerAlt,
  FaClock,
  FaWrench,
  FaCommentDots,
  FaExclamationCircle,
  
} from 'react-icons/fa';

const Support = () => {
  return (
    <div className="support_container">
      <h1>Support – Hiten Technologies</h1>
      <p>
        We’re here to help you. At Hiten Technologies, your satisfaction and smooth experience with our products and services are our top priorities. 
        Our support team is ready to assist you with any technical issues, questions, or guidance you may need.
      </p>

      {/* Centralized Contact Info */}
      <section>
        <h2>Contact Information</h2>
        <ul style={{ lineHeight: "1.8" }}>
          <li><FaEnvelope className="contact-icon" /><strong>Email:</strong> support@hitentechnologies.com</li>
          <li><FaPhone className="contact-icon" /><strong>Phone:</strong> +91 98904 13967</li>
          <li> <FaMapMarkerAlt className="contact-icon" /><strong>Address:</strong> Flat No 304, B Wing, Rajveer Galaxy Sr No 3 Samarth Nagar Dighi, Pune, Maharashtra 411015</li>
          <li><FaClock className="contact-icon" /><strong>Office Hours:</strong> Monday – Friday, 10:00 AM – 6:00 PM</li>
        </ul>
      </section>

      {/* Types of Support */}
      <section >
        <h2>Types of Support</h2>
        <ul>
          <li> <FaExclamationCircle className="support-icon" /><strong>General Inquiries:</strong> Business inquiries, collaborations, or general questions can be directed to the contact information above.</li>
          <li><FaWrench className="support-icon" /><strong>Technical Support:</strong> Assistance with software, products, troubleshooting, installation, updates, or configuration. Provide product details and issue description for faster resolution.</li>
          <li><FaCommentDots className="support-icon" /><strong>Feedback & Suggestions:</strong> Share ideas, report bugs, and help us improve our services using the contact information above.</li>
        </ul>
      </section>

      {/* How to Get Help Quickly */}
      <section>
        <h2>How to Get Help Quickly</h2>
        <ul style={{ lineHeight: "1.8" }}>
          <li>Email us with a detailed description at <strong>support@hitentechnologies.com</strong></li>
          <li>Call us during office hours for urgent matters</li>
          <li>Include product name, version, and a clear description for faster resolution</li>
        </ul>
      </section>

      {/* Why Choose Us */}
      <section>
        <h2>Why Choose Hiten Technologies Support?</h2>
        <ul>
          <li>Expert Team – Skilled professionals ready to solve technical challenges</li>
          <li>Prompt Response – Queries are prioritized for quick resolution</li>
          <li>Reliable Assistance – Support designed to minimize downtime and disruption</li>
        </ul>
      </section>
    </div>
  );
};

export default Support;